import React, { ReactElement, useMemo, useCallback, useState } from "react";
import { QualityHubTaskListPanelGroupProps } from './QualityHubTaskListPanelGroup.types';
import { QualityHubTaskListPanelItem } from "../QualityHubTaskListPanelItem";
import { SmallBodyBolder } from "src/components/Text";
import { Conditional } from "src/components/Conditional";
import Visage2Icon from "src/visage2/Visage2Icon/Visage2Icon";

/**
 * Renders a single task list panel group.
 *
 * @param {QualityHubTaskListPanelGroupProps} props - The component props
 * @returns {ReactElement | null} The rendered component
 */
function QualityHubTaskListPanelGroup({
    group,
    onAddClick,
    onItemClick,
}: QualityHubTaskListPanelGroupProps): ReactElement | null {
    const [isCollapsed, setIsCollapsed] = useState(false);

    const itemElements = useMemo(
        () => group?.items?.map((item) => (
            <li className="QualityHubTaskListPanelGroup-listItem"
                key={item.key}>
                <QualityHubTaskListPanelItem item={item}
                                             onAddClick={onAddClick}
                                             onClick={onItemClick} />
            </li>
        )),
        [group.items, onItemClick]);

    const onHeaderClick = useCallback(
        () => setIsCollapsed((prev) => !prev),
        [group]);

    return (
        <div className="QualityHubTaskListPanelGroup">
            <div className="QualityHubTaskListPanelGroup-header"
                 onClick={onHeaderClick}>
                <SmallBodyBolder className="QualityHubTaskListPanelGroup-headerText"
                                 color="contentDark">
                    {group.label}
                </SmallBodyBolder>
                <div className="QualityHubTaskListPanelGroup-accordion-icon">
                    <Visage2Icon color="spintrGrey"
                                 icon={!isCollapsed ? "arrow-up-2" : "arrow-down-1"}
                                 size="medium" />
                </div>
            </div>
            <Conditional condition={!isCollapsed}>
                <ol className="QualityHubTaskListPanelGroup-list">
                    {itemElements}
                </ol>
            </Conditional>
        </div>
    );
}

export default QualityHubTaskListPanelGroup;

